import { useCallback, useState } from 'react';
import ServiceManager from 'services/ServiceManager';
import HandlerError from 'errors/HandlerError';
import ServerError from 'errors/ServerError';
import handlerRequestCanceling from 'utils/handlerRequestCanceling';

type ProfilePicturePayload = {
    ImageContentBase64: string;
};

export const useChangeProfilePicture = () => {
    const [error, setError] = useState<unknown>(null);
    const [isLoading, setLoading] = useState(false);

    const changeMemberProfilePicture = useCallback(async (memberId: string, payload: ProfilePicturePayload) => {
        try {
            setError(null);
            setLoading(true);

            const { data } = await ServiceManager.customMembersService('updateMemberProfilePicture', [{ memberId, payload }]);

            setLoading(false);

            return data;
        } catch (err) {
            handlerRequestCanceling(
                HandlerError({ setError, setLoading }),
            )(err);

            return null;
        }
    }, []);

    const deleteMemberProfilePicture = useCallback(async (memberId: string) => {
        try {
            setError(null);
            setLoading(true);

            const { data } = await ServiceManager.memberManagement('deleteMemberPicture', [memberId]);

            setLoading(false);

            return data;
        } catch (e) {
            const err = (e as { type?: unknown })?.type !== undefined ? e : new ServerError(e);

            if ((err as { error?: { response?: { status?: number } } })?.error?.response?.status === 404) {
                setLoading(false);
            } else {
                handlerRequestCanceling(
                    HandlerError({ setError, setLoading }),
                )(e);
            }

            return err;
        }
    }, []);

    return {
        error,
        isLoading,
        changeMemberProfilePicture,
        deleteMemberProfilePicture,
    };
};
